<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click="$router.push('/cobranza')" style="cursor: pointer">Cobranza</li>
                <li class="breadcrumb-item active" aria-current="page">{{id}}</li>
            </ol>
        </nav>
        <div class="container-fluid">
            <project-info :project_id="id" v-if="id != null" ref="project_information" @updated="update"></project-info>
            <br>
            <project-payments :project_id="id"  v-if="id != null" ref="project_payments" @updated="update"></project-payments>
            <br>
            <pay-funds :project_id="id" v-if="id != null" ref="project_funds" @updated="update"></pay-funds>
        </div>
    </div>

</template>

<script>
    let project_info = require("./components/ProjectInfo").default;
    let pay_funds = require("./components/PayFunds").default;
    let project_payments = require("./components/Payments").default;
    export default {
        name: "ProjectView",
        components:{
            'project-info': project_info,
            'pay-funds': pay_funds,
            'project-payments': project_payments
        },
        mounted(){
            this.id = this.$route.params.id;
            window.document.title = "PID: "+this.id+" - Cobranza";
        },
        data(){
            return {
                id: null,
            }
        },
        methods:{
            async update(){
                await this.$refs.project_information.getInformation()
                // this.$refs.project_payments.reset()
                await this.$refs.project_funds.getInformation()
            }
        }
    }
</script>

<style scoped>

</style>